import { render, staticRenderFns } from "./SettingItems.vue?vue&type=template&id=88cb3ee2"
import script from "./SettingItems.vue?vue&type=script&lang=js"
export * from "./SettingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports